/* eslint-disable no-param-reassign */
import type { AxiosError } from "axios";
import axios, { AxiosRequestConfig } from "axios";
import { LOCAL_STORE_ITOKEN, LOCAL_STORE_TOKEN_BEARER } from "../../constants";
import { showMessage } from "../../utils/messages";
import { getIdSistema } from "./idSistema";
export const BASE_URL = process.env.REACT_APP_BASE_URL_IP;

const create = (baseURL = BASE_URL) => {
  const axiosInstance = axios.create({ baseURL });

  //Usando interceptors para que se existir um token ele irá enviar pela request.
  axiosInstance.interceptors.request.use(
    (config: AxiosRequestConfig): AxiosRequestConfig => {
      const token = localStorage.getItem(LOCAL_STORE_ITOKEN);
      const token_Bearer = localStorage.getItem(LOCAL_STORE_TOKEN_BEARER);
      const xCode = sessionStorage.getItem("@NovaEra:xCode");

      if(config.headers != null){
        if (token) config.headers.apikey = `token ${token.replaceAll('"', '')}`;
        if (token_Bearer) config.headers.Authorization = `Bearer ${token_Bearer.replaceAll('"', '')}`;
        if (xCode) config.headers.XCODE = xCode;
        config.headers["Id-Sistema"] = getIdSistema();
      }

      return config;
    },
    (err: AxiosError) => {
      return Promise.reject(err);
    },
  );

  // Espelha o tratamento de 401/403 do hooks/useApi.ts (fetch): sem isso, uma chamada
  // bloqueada pelo HorarioFuncionalFilter (ex.: o handshake de token-publico, que passa
  // por aqui) cai direto no catch local de quem chamou, mostrando um modal generico sem
  // a mensagem do backend. Fora do horario funcional e o unico motivo de bloqueio para o
  // totem. Mostra a mensagem aqui mesmo e permanece na tela atual (sem navegar) — so marca
  // o erro para quem chamou nao exibir um segundo modal duplicado.
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        const mensagem = (
          error.response?.data as { mensagem?: string } | undefined
        )?.mensagem;
        showMessage(
          "warning",
          "Atenção!",
          mensagem ||
            "Fora do horário de atendimento. Tente novamente durante o horário de funcionamento.",
          { timer: 5000, showConfirmButton: true },
        );
        (
          error as AxiosError & { horarioRestritoTratado?: boolean }
        ).horarioRestritoTratado = true;
      }
      return Promise.reject(error);
    },
  );

  return axiosInstance;
};

export default create();
